import { FinalSubmitPayload } from '../types/role.types'
import axiosInstance from '../utils/axiosInstance'
import { API_END_POINT } from '../utils/environment'

const getAssignedRolesForUser = async (payload: string) => {
  return await axiosInstance.get(`${API_END_POINT.CORE}users/${payload}/roles`)
}

const getProgramsList = async (clientId?: string | number) => {
  return await axiosInstance.get(
    `${API_END_POINT.CORE}programs?enabled=true`,
    clientId !== undefined && clientId !== null
      ? {
          headers: {
            'X-TenantId': clientId,
          },
        }
      : {}
  )
}

const getServicesList = async () => {
  return await axiosInstance.get(`${API_END_POINT.CORE}services`)
}

const getServicesFromProgramId = async (programId: number | string) => {
  return await axiosInstance.get(
    `${API_END_POINT.CORE}aws-connect/programs/${programId}/services`
  )
}
const getProductsList = async () => {
  return await axiosInstance.get(`${API_END_POINT.CORE}products`)
}
const getTerritoriesList = async () => {
  return await axiosInstance.get(`${API_END_POINT.CORE}territories`)
}
const getRoles = async (sendClientId = true) => {
  return await axiosInstance.get(
    `${API_END_POINT.CORE}roles`,
    sendClientId
      ? {}
      : {
          headers: {
            'X-TenantId': '',
          },
        }
  )
}
const putSaveData = async (payload: FinalSubmitPayload) => {
  return await axiosInstance.put(
    `${API_END_POINT.CORE}users/${payload?.roles?.[0].user_id}/roles`,
    payload
  )
}

export {
  getAssignedRolesForUser,
  getProgramsList,
  getServicesList,
  getProductsList,
  getTerritoriesList,
  getRoles,
  putSaveData,
  getServicesFromProgramId,
}
